import React from "react";

export const ReturnIcon = ({ color }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={13}
        height={10}
        viewBox='0 0 13 10'
        fill='none'>
        <path
            d='M10.4508 4.48344L8.28509 2.31198C8.15626 2.18317 8.08085 2.01024 8.07401 1.82795C8.06718 1.64566 8.12942 1.46754 8.24824 1.32939C8.36705 1.19125 8.53362 1.10332 8.71446 1.08329C8.89529 1.06327 9.07699 1.11262 9.22301 1.22144L9.30365 1.2917L12.6982 4.69423L12.7635 4.77123L12.8019 4.82706L12.8499 4.9185L12.8816 5.00705L12.896 5.07154L12.9056 5.13122L12.9084 5.2217L12.9046 5.27849L12.8902 5.36896L12.8614 5.46522L12.8163 5.55954L12.7827 5.61248C12.7578 5.64936 12.7295 5.68384 12.6982 5.71547L12.7635 5.63943C12.7435 5.66626 12.7217 5.69167 12.6982 5.71547L9.30365 9.118C9.17501 9.24598 9.00297 9.32061 8.82186 9.32701C8.64076 9.3334 8.46391 9.27109 8.32661 9.1525C8.18931 9.03392 8.10166 8.86778 8.08115 8.68725C8.06064 8.50673 8.10878 8.32508 8.21597 8.17858L8.28509 8.09773L10.4508 5.92723L6.90845 5.92723C3.40349 5.92723 1.02173 3.92806 0.912288 1.07899L0.908447 0.873967C0.908447 0.682509 0.984305 0.498892 1.11933 0.36351C1.25436 0.228129 1.43749 0.152072 1.62845 0.152072C1.8194 0.152072 2.00254 0.228129 2.13756 0.36351C2.27259 0.498892 2.34845 0.682509 2.34845 0.873967C2.34845 2.92222 3.97277 4.39489 6.66173 4.47959L6.90845 4.48344L10.4508 4.48344Z'
            fill={color || "#2d67ad"}
        />
    </svg>
);

export const LoadingIcon = ({ color }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={18}
        enableBackground='new 0 0 50 50'
        version='1.1'
        viewBox='0 0 50 50'
        xmlSpace='preserve'>
        <path
            fill={color || "#2d67ad"}
            d='M43.935 25.145c0-10.318-8.364-18.683-18.683-18.683-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615s14.615 6.543 14.615 14.615h4.068z'>
            <animateTransform
                attributeName='transform'
                attributeType='xml'
                dur='0.6s'
                from='0 25 25'
                repeatCount='indefinite'
                to='360 25 25'
                type='rotate'
            />
        </path>
    </svg>
);
